module.exports = __webpack_public_path__ + "static/media/GoogleLog.690ae63d.svg";